import React from 'react';
import Main from './components/Main';
import Navbar from './components/Navbar/Navbar';
import Footer from './components/Footer/Footer';
import './sass/style.css'
import { library } from '@fortawesome/fontawesome-svg-core';
import { faFacebook, faYoutube, faInstagram, faTwitter, faLinkedin, } from '@fortawesome/free-brands-svg-icons';

library.add( faFacebook,
  faTwitter, faYoutube, faInstagram,  faLinkedin);


const App = () => (
	<div>
		<Navbar/>
		<Main/>
		<Footer/> 
	</div>
)

export default App;
